import { useState, useEffect } from 'react';
import { useSnackbar } from "../../hook/useSnackbar";
import { getAllAplicaciones } from "../../utils/AplicacionesUtils";

export default function SelectComponent({ props, setValue , register}) {

    const [activeSelect, setActiveSelect] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [listOpt, setListOpt] = useState([]);
    const { showSnackbar } = useSnackbar();
    const [error, setError] = useState(false);

    const validateSelection = () => {
        if (!selectedOption) {
            setError(true);
            return false; // Retorna falso si la validación falla
        }
        return true; // Retorna verdadero si la validación es exitosa
    };

    useEffect(() => {
        register(props.name + 'LookupId', { required: props.required });

        // Para el campo aplicacion_busint, cargar desde JSON con IDs correctos
        if (props.name === 'aplicacion_busint' && listOpt.length === 0) {
            const aplicaciones = getAllAplicaciones();
            const options = aplicaciones.map(app => ({
                id: app.id,
                muestra_cliente: app.label
            }));
            setListOpt(options);
        }
        // Para campos choice, usar las opciones definidas en el JSON
        else if (props.choice && props.choice.choices && listOpt.length === 0) {
            const options = props.choice.choices.map((choice, index) => ({
                id: index + 1,
                muestra_cliente: choice
            }));
            setListOpt(options);
        }

        // Para campos lookup, las opciones deberían estar en props.choice.choices también
        // Si no están, mostrar mensaje de error
        if (props.type === "lookup" && (!props.choice || !props.choice.choices) && props.name !== 'aplicacion_busint') {
            console.warn(`El campo lookup "${props.name}" no tiene opciones definidas en choice.choices`);
        }

        validateSelection()

        return () => { }
    }, [])

    function activeSelectArrow() {
        setActiveSelect(!activeSelect);
    }


    const handleOptionClick = (value) => {
        setSelectedOption('item_' + value);
        setValue(props.name + 'LookupId', value, { shouldValidate: true } );
        setError(false); 
    }; 

    return (
        props.hidden ? null :
            <div >
                <label htmlFor={props.id}>
                    {props.displayName}
                    <span>{props.description}</span>
                </label>
                <div onClick={activeSelectArrow} className={`select ${props.required && selectedOption === ''  ? 'error' : ''} ${activeSelect ? 'active' : ''} ${selectedOption ? 'selected' : ''}`}>
                    <div name={props.name} id={props.id} data-value={selectedOption} className={`selected-item ${selectedOption ? 'selected' : ''}`}  >{selectedOption ? null : 'Aplicaciones'}</div>
                    <ul>
                        {
                            listOpt.map((item, key) => (
                                <li key={'app_ind_uniq_' + key} onClick={() => handleOptionClick(item.id)} data-value={'item_' + item.id} >{item.muestra_cliente}</li>
                            ))
                        }
                    </ul>
                </div>
                {error && <span className='error-message'>Debes elegir {props.displayName}</span>}
            </div>
    )
}